import { useState, useEffect, useRef } from "react";
import Dasboard from "../dasboard/dashboard";
import clienteAxios from "../../axios";
import Cargador from "../../componentes/Cargador";


const Premios = () => {
    const [editar, setEditar] = useState(false);
    const [nuevo, setNuevo] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [premioActual, setPremioActual] = useState(null);

    const [isOpen, setIsOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const inputRef = useRef(null);
    const [ListaPremios, setListaPremios] = useState([]);
    const [color, setColor] = useState("#3498db");
    const [cargador, setCargador] = useState(false);

    const consultarPremios = async () => {

        const config = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
        const data = {
            "sp": "premios",
            "op": "listar",
        }

        try {
            setCargador(true);
            const result = await clienteAxios.post("/api/sp", data, config);
            setListaPremios(result.data.data[0]);
        } catch (error) {
            console.error("Error al consultar premios:", error);
        } finally {
            setCargador(false);
        }
    };

    useEffect(() => {
        consultarPremios();
    }, []);

    const handleEditar = (item) => {
        setOpenModal(true)
        setEditar(true);
        setNuevo(false);
        setPremioActual(item);
    };

    const handleNuevo = () => {
        setOpenModal(true)
        setNuevo(true);
        setEditar(false);
        setPremioActual({ descripcion: "", valor: "", url: "" });
    };

    const handleGuardar = async (item) => {
        let opcion = ''

        const config = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("token")}`
        }

        if (editar) {
            opcion = 'actualizar'
        } else if (nuevo) {
            opcion = 'agregar'
        }
        let data = {
            "sp": "premios",
            "op": opcion,
            "descripcion": item.descripcion,
            "valor": item.valor,
            "url": item.url,
            "idPremio": item.idPremio,
            "color": color
        }
        try {
            setCargador(true);
            await clienteAxios.post("/api/sp", data, config);
            setFile(null);
            consultarPremios();
            setOpenModal(false);
        } catch (error) {
            console.error("Error al guardar premio:", error);
        } finally {
            setCargador(false);
        }
    }

    const closeModal = () => {
        setIsOpen(false);
        setFile(null);
        setPreview(null);
    };

    const handleFile = (f) => {
        if (!f) return;
        setFile(f);
        if (f.type.startsWith("image/")) {
            const reader = new FileReader();
            reader.onload = (e) => setPreview(e.target.result);
            reader.readAsDataURL(f);
            reader.onloadend = () => {
                setPremioActual({ ...premioActual, url: reader.result }); // Asignar la URL de la imagen al premio actual
            };
        } else {
            setPreview(null);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        const f = e.dataTransfer.files[0];
        handleFile(f);
    };

    const eliminarPremio = async (idPremio) => {
        const config = {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${localStorage.getItem("token")}`
        }

        let data = {
            "sp": "premios",
            "op": "eliminar",
            "idPremio": idPremio
        }
        try {
        setCargador(true);
        await clienteAxios.post("/api/sp", data, config);
        setFile(null);
        // fileInputRef.current.value = "";
        setOpenModal(false);
        consultarPremios();
        }
        catch (error) {
            console.error("Error al eliminar premio:", error);
        } finally {
            setCargador(false);
        }
    };

    return (
        <>
            <Dasboard />
            <main className="-mt-32 ">
                <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                    <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden min-h-screen relative  ">
                        <button className="absolute right-2 bg-green-500 text-white p-2 rounded" onClick={() => { handleNuevo(); setOpenModal(true); }}>Nuevo</button>
                        <h2 className="text-2xl font-bold mb-6 mt-4">Premios</h2>
                        {cargador && <Cargador />}
                        {openModal && (
                            <div className="fixed inset-0 z-50 "
                            >
                                <div className="p-4 rounded  shadow-xl absolute inset-0 bg-black/60 backdrop-blur-[2px] transition-opacity">

                                    <div className=" sm:w-full flex flex-col items-center justify-center bg-white md:w-1/2 m-auto rounded-2xl p-4 relative">
                                        <div className="absolute top-2 left-2">
                                            <button className="bg-red-500 text-white px-4 rounded-2xl" onClick={() => eliminarPremio(premioActual.idPremio)}>Eliminar premio</button>
                                        </div>

                                        <button className="p-2 rounded-xl hover:bg-gray-700 hover:text-white top-4 right-4 absolute" onClick={() => setOpenModal(false)}>
                                            ✕
                                        </button>
                                        <h3 className="text-xl font-bold py-4">{nuevo ? "Nuevo" : "Editar"} Premio</h3>
                                        <div className="text-start w-full p-4">
                                            <label className="block text-sm font-medium text-gray-700 py-2 ">Descripción</label>
                                            <input className="border border-gray-300 rounded-md p-2 w-full" placeholder="Descripción del Premio" value={premioActual.descripcion} onChange={(e) => setPremioActual({ ...premioActual, descripcion: e.target.value })} />
                                        </div>

                                        <div className="w-full space-y-3">

                                            <div className="w-full  md:flex ">

                                                <div className="w-full p-4 space-y-3">
                                                    <label className="block text-sm font-medium text-gray-700">Porcentaje</label>
                                                    <select
                                                        value={premioActual.valor}
                                                        onChange={(e) => setPremioActual({ ...premioActual, valor: e.target.value })}
                                                        className="p-2 border rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 w-1/2"
                                                    >
                                                        {[...Array(11).keys()].map((i) => {
                                                            const value = i * 10;
                                                            return (
                                                                <option key={value} value={value}>
                                                                    {value}%
                                                                </option>
                                                            );
                                                        })}
                                                    </select>

                                                </div>

                                                <div className="w-full p-4 space-y-3">
                                                    <label className="block text-sm font-medium text-gray-700">Color del premio en la ruleta</label>
                                                    <input
                                                        type="color"
                                                        value={premioActual.color}
                                                        onChange={(e) => setColor(e.target.value)}
                                                        className="w-16 h-10 cursor-pointer rounded border border-gray-300"
                                                    />
                                                </div>
                                            </div>

                                            <div
                                                onClick={() => inputRef.current.click()}
                                                onDragOver={(e) => e.preventDefault()}
                                                onDrop={handleDrop}
                                                className="mt-4 flex flex-col items-center justify-center w-full p-6 border-2 border-dashed border-gray-300 rounded-xl bg-gray-50 cursor-pointer transition hover:bg-gray-100"
                                            >
                                                <svg
                                                    className="w-10 h-10 text-gray-400 mb-2"
                                                    fill="none"
                                                    stroke="currentColor"
                                                    viewBox="0 0 24 24"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        strokeWidth="2"
                                                        d="M7 16V4m0 0l-4 4m4-4l4 4M17 8v12m0 0l-4-4m4 4l4-4"
                                                    />
                                                </svg>
                                                <p className="text-sm text-gray-600">
                                                    Suelta el archivo aquí o{" "}
                                                    <span className="text-blue-600 underline">haz clic</span>
                                                </p>
                                                <input
                                                    type="file"
                                                    ref={inputRef}
                                                    className="hidden"
                                                    accept="image/*"
                                                    onChange={(e) => handleFile(e.target.files[0])}
                                                />
                                            </div>

                                            {/* Vista previa */}
                                            {file ?
                                                <div className="mt-4 justify-center items-center text-center">
                                                    <p className="text-sm font-medium text-gray-700">
                                                        Archivo seleccionado:
                                                    </p>
                                                    <p className="text-sm text-gray-600 mt-1">
                                                        {file.name} ({Math.round(file.size / 1024)} KB)
                                                    </p>
                                                    {preview && (
                                                        <img
                                                            src={preview}
                                                            alt="preview "
                                                            className="mt-3 max-h-40 rounded-lg shadow m-auto"
                                                        />
                                                    )}
                                                </div>
                                                :

                                                <div className="mt-4 justify-center items-center text-center">
                                                    {premioActual.url && (
                                                        <img
                                                            src={premioActual.url}
                                                            alt="preview "
                                                            className="mt-3 max-h-40 rounded-lg shadow m-auto"
                                                        />
                                                    )}
                                                </div>
                                            }

                                            <div className="w-full space-y-3 md:space-y-0 md:flex md:space-x-2 mt-4">
                                                <button className="bg-green-500 text-white w-full p-2" onClick={() => { setOpenModal(false); handleGuardar(premioActual); }}>Guardar</button>
                                                <button className="bg-gray-700 text-white w-full p-2" onClick={() => { setEditar(false); setOpenModal(false) }}>Cancelar</button>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </div>

                        )}
                        <>
                            <ul className='w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4'>
                                {ListaPremios.map((item, index) => (
                                    <li key={index} className='w-full space-y-3 bg-gray-100 p-4 rounded shadow-md m-2'>
                                        <div className={`h-8 rounded w-1/2 text-white text-center p-1`} style={{ "backgroundColor": item.color }} >Color seleccionado</div>
                                        <strong>{`Premio ${index + 1}`}</strong>: {item.descripcion}
                                        <p><strong>{`Valor:`}</strong>{item.valor}</p>
                                        <img src={item.url} alt={`Premio ${index + 1}`} className="mt-2 max-h-44  rounded-lg shadow m-auto object-cover" />
                                        <button className='bg-blue-500 text-white rounded w-full h-10' onClick={() => { handleEditar(item); setOpenModal(true); }}>Editar</button>
                                    </li>
                                ))}
                            </ul>
                        </>

                    </div>
                </div>
            </main >

        </>
    );
};

export default Premios;
